import { Client } from "@xmpp/client"
import { getAllItems } from "./PubSub"
import { Element } from "@xmpp/xml"
import { wizardJid } from "@/jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import CarsParser, { CARS_NODE } from "@/lib/carsParser"
import { Car } from "@/reducers/carsSlice"

export const retrieveAllCars = async (xmpp: Client): Promise<Array<Car>> => {
  const result = await getAllItems({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: CARS_NODE,
    timeout: 4000,
  })

  const items = result
    .getChild("pubsub")
    ?.getChild("items")
    ?.getChildren("item") as [Element]

  if (!items) return []

  return items.map((item) => {
    return CarsParser.parseItem(item)
  })
}

export const subscribeToCars = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(
      window.XMPP!,
      wizardJid(client.jid!),
      CARS_NODE,
    )
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      console.warn(`Error subscribing to ${CARS_NODE}`, error)
    }
  }
}
